import { render } from "./NegociosView.vue?vue&type=template&id=152e355a&ts=true"
import script from "./NegociosView.vue?vue&type=script&lang=ts"
export * from "./NegociosView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__